export function useChatwoot() {
    const openChat = () => {
        if (typeof window === "undefined") {
            return;
        }

        if (window.$chatwoot && typeof window.$chatwoot.toggle === "function") {
            window.$chatwoot.toggle("open");

            return;
        }

        window.addEventListener("chatwoot:ready", () => {
            if (window.$chatwoot && typeof window.$chatwoot.toggle === "function") {
                window.$chatwoot.toggle("open");
            }
        }, { once: true });
    };

    return { openChat };
}
